








import Vue from "vue";

interface Computed {
  badgeIcon: string;
}

interface Props {
  displayDelay: number;
  show: boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  name: "SingleSentenceReadingToast",
  components: {},

  props: {
    displayDelay: { type: Number, default: 2000 },
    show: { type: Boolean, default: false }
  }
});
